import axios from 'axios';
import { Message } from 'element-ui';
import { config } from '../config';

// 创建 axios 实例
const service = axios.create({
  baseURL: config.baseURL, // 使用配置文件中的 API 地址
  timeout: 5000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可以在这里添加请求头，例如 token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `${token}`;
    }
    return config;
  },
  error => {
    // 处理请求错误
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    
    if (res.code !== 200 && response.config.responseType !== "arraybuffer") {
      if (res.code !== 401) {
        Message({
          message: res.msg || 'Error',
          type: 'error',
          duration: 5000,
        });
      }
      return Promise.reject(new Error(res.msg || 'Error'));
    } else {
      return res;
    }
  },
  error => {
    // 处理响应错误
    Message({
      message: error.message,
      type: 'error',
      duration: 5000,
    });
    return Promise.reject(error);
  }
);

export default service;
